import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_STRUCTURE,
  GET_POSITION,
  DELETE_POSITION,
  UPDATE_POSITION,
  ADD_NEW_POSITION,
} from "./actionType";

import {
  getPositionSuccess,
  getPositionFail,
  deletePositionSuccess,
  deletePositionFail,
  updatePositionSuccess,
  updatePositionFail,
  addPositionSuccess,
  addPositionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getPositionApi,
  updatePositionApi,
  deletePositionApi,
  addNewPositionApi
} from "../../helpers/backend_helper";

function* getPosition({ payload: position , path}) {
  try {
    const response = yield call(getPositionApi, position, path);
    yield put(getPositionSuccess(GET_POSITION, response.data));
  } catch (error) {
    yield put(getPositionFail(GET_POSITION, error));
  }
}

function* getStructure({ payload: position , path}) {
  try {
    const response = yield call(getPositionApi, position, path);
    yield put(getPositionSuccess(GET_STRUCTURE, response.data));
  } catch (error) {
    yield put(getPositionFail(GET_STRUCTURE, error));
  }
}

function* onUpdatePosition({ payload: position }) {
  try {
    const response = yield call(updatePositionApi, position);
    yield put(updatePositionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updatePositionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePosition({ payload: position }) {
  try {
    const response = yield call(deletePositionApi, position);
    yield put(deletePositionSuccess({ position, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePositionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPosition({ payload: position }) {
  try {
    const response = yield call(addNewPositionApi, position);
    yield put(addPositionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPositionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetStructureAll() {
  yield takeEvery(GET_STRUCTURE, getStructure);
}

export function* watchGetPosition() {
  yield takeEvery(GET_POSITION, getPosition);
}

export function* watchUpdatePosition() {
  yield takeEvery(UPDATE_POSITION, onUpdatePosition);
}

export function* watchDeletePosition() {
  yield takeEvery(DELETE_POSITION, onDeletePosition);
}

export function* watchAddNewPosition() {
  yield takeEvery(ADD_NEW_POSITION, onAddNewPosition);
}

function* positionSaga() {
  yield all([
    fork(watchGetStructureAll),
    fork(watchGetPosition),
    fork(watchDeletePosition),
    fork(watchUpdatePosition),
    fork(watchAddNewPosition)
  ]);
}

export default positionSaga;
